import { UNSAFE_BREAKPOINTS_CONFIG, UNSAFE_buildAboveMediaQueryCSS } from '@atlaskit/primitives/responsive';
export var gapMediaQueries = Object.values(UNSAFE_buildAboveMediaQueryCSS(function (breakpoint) {
  return {
    gap: UNSAFE_BREAKPOINTS_CONFIG[breakpoint].gridItemGutter
  };
}));
export var inlinePaddingMediaQueries = Object.values(UNSAFE_buildAboveMediaQueryCSS(function (breakpoint) {
  return {
    paddingInline: UNSAFE_BREAKPOINTS_CONFIG[breakpoint].gridMargin
  };
}));